import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var QueryClass;
function Query() {
  if (QueryClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Query');
    QueryClass = $;
  }
  return QueryClass;
}
//region block: exports
export {
  Query as Query2hw717wsl0l5r,
};
//endregion

//# sourceMappingURL=Query.mjs.map
